import { React, useState, useEffect, Card, Avatar, Toast, Breadcrumb, CustomTable, _formatDate, CustomModal } from "../utils/commonImports";
import { Button, Alert, DatePicker } from "antd";
import { Icon } from "@iconify/react";
import { _api } from '../auth/Api';
import dayjs from "dayjs";
import { _exportToExcel } from "../helper/ExportToExcel";

const ContactUs = () => {
  const [contacts, setContacts] = useState([]);
  const [viewModal, setViewModal] = useState({ isOpen: false, data: null });
  const [filterBtnShow, setFilterBtnShow] = useState(true);
  // Pagination states
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [totalRecords, setTotalRecords] = useState(0);
  // Loading & validation
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [showExp, setShowExp] = useState(false);
  // Filters
  const initialFilters = {
    fullName: "",
    email: "",
    phoneNumber: "",
    subject: "",
    createdDateTo: null,
    createdDatefrom: null,
  };
  const [filters, setFilters] = useState(initialFilters);

  useEffect(() => {
    _getContacts();
  }, []);

  const _getContacts = async (filterValues = {}, pageNo = page, numberOfRecords = pageSize) => {
    const payload = {
      fullName: filterValues.fullName || "",
      email: filterValues.email || "",
      phoneNumber: filterValues.phoneNumber || "",
      subject: filterValues.subject || "",
      createdDateTo: filterValues.createdDateTo ? dayjs(filterValues.createdDateTo).format("YYYY-MM-DD") : null,
      createdDatefrom: filterValues.createdDatefrom ? dayjs(filterValues.createdDatefrom).format("YYYY-MM-DD") : null,
      page: {
        pageNo: pageNo,
        numberOfRecords: numberOfRecords,
      },
    };
    setLoading(true);
    try {
      await _api("POST", "ContactUs/GetAllContactById", payload, (res) => {
        if (res.isSuccess) {
          setContacts(res.data);
          setTotalRecords(res.totalRecords || 0);
        } else {
          setContacts([]);
          // Toast.fire({ icon: "error", title: res.message });
        }
      });
    } catch (error) {
      console.error(error);
      setContacts([]);
      Toast.fire({ icon: "error", title: "Failed to fetch contact queries" });
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = (pagination) => {
    setPage(pagination.current);
    setPageSize(pagination.pageSize);
    _getContacts(filters, pagination.current, pagination.pageSize);
  };

  const handleReset = () => {
    setShowExp(false);
    setFilters(initialFilters);
    setPage(1);
    _getContacts(initialFilters, 1, pageSize);
  };

  const handleApply = () => {
    const { fullName, email, phoneNumber, subject, createdDateTo, createdDatefrom } = filters;
    if (!fullName && !email && !phoneNumber && !subject && !createdDateTo && !createdDatefrom) {
      setShowExp(true);
      return;
    }
    _getContacts(filters, 1, pageSize);
  };

  const launchDetailModal = (type, record) => {
    setViewModal({ isOpen: type, data: record });
  };

  const columns = [
    { title: "Full Name", dataIndex: "fullName", },
    {
      title: "Contact Info",
      dataIndex: "email",
      render: (_, record) => (
        <div>
          <div className="small">{record.phoneNumber}</div>
          <div className="text-muted small">{record.email}</div>
        </div>
      ),
    },
    { title: "Subject", dataIndex: "subject" },
    // { title: "Description", dataIndex: "description" },
    {
      title: "Created Date",
      dataIndex: "createDate",
      render: (createDate) => _formatDate(createDate),
    },
    {
      title: "Details",
      render: (_, record) => (
        <Button
          icon={<Icon icon="feather:eye" />}
          onClick={() => launchDetailModal(true, record)}
        />
      ),
    },
  ];

  const xlsColumns = [
    //{ title: "User Id", dataIndex: "userId" },
    { title: "Customer Name", dataIndex: "fullName" },
    { title: "Email", dataIndex: "email" },
    { title: "Contact No", dataIndex: "phoneNumber" },
    { title: "Subject", dataIndex: "subject" },
    { title: "Description", dataIndex: "description" },
    { title: "Created On", dataIndex: "createDate" },
    //{ title: "Status", dataIndex: "status" },
  ]
  const handleExport = async () => {
    setBtnLoading(true);

    const payload = {
      fullName: "",
      email: "",
      phoneNumber: "",
      subject: "",
      createdDate: null,
      page: {
        pageNo: 0,
        numberOfRecords: 0,
      },
    };

    try {
      await _api("POST", "ContactUs/GetAllContactById", payload, (res) => {
        if (res.isSuccess) {
          const krDateSahe = res.data.map((x) => ({
            ...x,
            createDate: _formatDate(x.createDate),
          }));

          setTimeout(() => {
            _exportToExcel({
              data: krDateSahe,
              columns: xlsColumns,
              fileName: "Contact us Quiries",
            });
            setBtnLoading(false);
          }, 1500);
        } else {
          setBtnLoading(false);
        }
      });
    } catch (error) {
      console.error(error);
      setBtnLoading(false);
    }
  };

  return (
    <>
      <Breadcrumb title="Contact Us Queries" />

      {filterBtnShow && (
        <Card className="mb-3">
          {/* Filters */}
          <div className="p-2 bg-white">
            <div className="row g-2">
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Full Name"
                  value={filters.fullName}
                  onChange={(e) => setFilters({ ...filters, fullName: e.target.value })}
                />
              </div>

              <div className="col-md-3">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  value={filters.email}
                  onChange={(e) => setFilters({ ...filters, email: e.target.value })}
                />
              </div>

              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Phone Number"
                  value={filters.phoneNumber}
                  onChange={(e) => setFilters({ ...filters, phoneNumber: e.target.value })}
                />
              </div>

              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Subject"
                  value={filters.subject}
                  onChange={(e) => setFilters({ ...filters, subject: e.target.value })}
                />
              </div>

              <div className="col-md-3">
                <DatePicker
                  format="YYYY-MM-DD"
                  value={filters.createdDatefrom ? dayjs(filters.createdDatefrom) : null}
                  onChange={(date) => setFilters({ ...filters, createdDatefrom: date })}
                  style={{ width: "100%" }}
                  disabledDate={(current) => {
                    if (current && current > dayjs().endOf("day")) return true;
                    if (filters.createdDateTo && current > dayjs(filters.createdDateTo)) return true;
                    return false;
                  }}
                  placeholder="Created Date (From)"
                />
              </div>

              <div className="col-md-3">
                <DatePicker
                  format="YYYY-MM-DD"
                  value={filters.createdDateTo ? dayjs(filters.createdDateTo) : null}
                  onChange={(date) => setFilters({ ...filters, createdDateTo: date })}
                  style={{ width: "100%" }}
                  disabledDate={(current) => {
                    if (current && current > dayjs().endOf("day")) return true;
                    if (filters.createdDatefrom && current < dayjs(filters.createdDatefrom)) return true;
                    return false;
                  }}
                  disabled={!filters.createdDatefrom}
                  placeholder="Created Date (To)"
                />
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-between gap-2 mt-3">
              <div className="flex-grow-1">
                {showExp && (
                  <Alert
                    showIcon
                    message="NOTE: Please fill at least one filter"
                    type="warning"
                  />
                )}
              </div>
              <div className="d-flex gap-2">
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => setFilterBtnShow(false)}
                >
                  Hide Filter
                </button>
                <button className="btn btn-sm btn-outline-secondary" onClick={handleReset}>
                  Reset Filters
                </button>
                <button className="btn btn-sm btn-primary" onClick={handleApply}>
                  Apply Filters
                </button>
              </div>
            </div>
          </div>
        </Card>
      )}

      <Card>
        <div className="d-flex justify-content-end gap-2" style={{ marginBottom: "10px" }}>
          {!filterBtnShow && (
            <button
              onClick={() => setFilterBtnShow(true)}
              className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm mb-2"
              style={{ lineHeight: "1.2" }}
            >
              Filter Queries
              <Icon icon="mdi:filter-cog-outline" className="text-md" />
            </button>
          )}
          <button
            onClick={handleExport}
            className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm mb-2"
            style={{ lineHeight: '1.2' }}
            disabled={btnLoading}
          >
            {btnLoading && (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
            )}
            {btnLoading ? "Exporting..." : "Export to Excel"}
            <Icon icon="mdi:microsoft-excel" className="text-md" />
          </button>
        </div>

        <CustomTable
          columns={columns}
          dataSource={contacts}
          options={{
            withActions: false,
            loading: loading,
            bordered: true,
            size: "small",
            rowKey: "contactId",
            emptyText: "No contact queries found",
            pageKey: 8
          }}
          pagination={{
            current: page,
            pageSize: pageSize,
            total: totalRecords,
            showSizeChanger: true,
            currentLength: contacts.length,
          }}
          onChange={handleTableChange}
        />
      </Card>

      {/* Detail Modal */}
      <CustomModal
        show={viewModal.isOpen}
        onHide={() => setViewModal({ isOpen: false, data: null })}
        title="Contact Query Details"
      >
        {viewModal.data && (
          <div className="row g-3">
            <div className="col-md-6">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Full Name:</small>
                <div className="fw-semibold text-sm">
                  {viewModal.data?.fullName || "-"}
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Email:</small>
                <div className="fw-semibold text-sm">
                  {viewModal.data?.email || "-"}
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Phone:</small>
                <div className="fw-semibold text-sm">
                  {viewModal.data?.phoneNumber || "-"}
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Subject:</small>
                <div className="fw-semibold text-sm">
                  {viewModal.data?.subject || "-"}
                </div>
              </div>
            </div>

            <div className="col-12">
              <div className="border rounded p-3 bg-light shadow-sm">
                <small className="text-muted d-block mb-2">Message:</small>
                <div className="fw-semibold">{viewModal.data?.description || "-"}</div>
              </div>
            </div>
          </div>
        )}
      </CustomModal>

    </>
  );
};

export default ContactUs;